export * from './LegalAgreementFootnote';
export type { LegalAgreementFootnoteProps } from './types';
